<template>
  <div>
	  	<!-- breadcrumb -->
	 <div class="loading" v-if="loading">
   
<div class="loader">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>
    </div>
  <div v-if="fetch">
	<b-modal v-model="modalShow" ok-only centered centered class="text-center text-info">
      You are not logged in as a user!
    </b-modal>
	 <b-modal v-model="modalShow2" ok-only centered centered class="text-center text-info">
      Added To Cart
    </b-modal>
	<b-modal v-model="modalShow3" ok-only centered centered class="text-center text-info">
      Item Already In the Cart
    </b-modal>
      <!-- Product Detail -->
	 

	
		<div class="container p-t-45 p-b-60 mobi-m-p-100">
			<div class="row" style="height:auto;">
				<!-- :autoplay="true" :autoplay-timeout="5000" -->
				<carousel-3d style="height:480px;" :border="0" :controls-visible="ctrl" >
				<slide :index="0" style="height:auto;">
				<div :data-zoom="image" class="zoom">
				<img :src="image" alt="" >
				</div>
				</slide>
				<slide :index="1" style="height:auto;" >
				<div :data-zoom="otherimgs[0]" class="zoom" >
				<img :src="otherimgs[0]" alt="">
				</div>
				</slide>
				<slide :index="2" style="height:auto;" >
				<div :data-zoom="otherimgs[1]" class="zoom" >
				<img :src="otherimgs[1]" alt="">
				</div>
				</slide>
				<slide :index="3" style="height:auto;" >
				<div :data-zoom="otherimgs[2]" class="zoom" >
				<img :src="otherimgs[2]" alt="">
				</div>
				</slide>
				<slide :index="4" style="height:auto;" >
				<div :data-zoom="otherimgs[3]" class="zoom">
				<img :src="otherimgs[3]" alt="">
				</div>
				</slide>
			</carousel-3d>
					
				
			</div>
			<div class="container">
			<div class="row">
			<div class="col-sm-12 col-lg-12 p-t-10 p-b-30 mx-auto text-center mobi-m-p-0"  >
					<div class=" p-t-5 p-lr-0-lg mx-auto text-center">
						<h4 class="mtext-105 cl13 js-name-detail p-b-14">
							{{formdata.name}}
						</h4>

						<span class="mtext-106 cl13">
							RS {{formdata.price}}
						</span>

						
						
						<!--  -->
						<div class="p-t-33">
							
							

							<div class="flex-w flex-t p-b-10">
								<div class="size-204 m-l-56" >

									<button @click="addToCart()" class="flex-c-m stext-101 cl0 size-101 bg1 bor1 hov-btn1 p-lr-15 mb-3 trans-04  mx-auto text-center">
										Add to Cart
									</button>
									<button @click="cartClicked()"class="flex-c-m stext-101 cl0 size-101 bg10 bor1 hov-btn1 p-lr-15 trans-04  mx-auto">
									View cart
									</button>
								</div>
							</div>	
						</div>

						
					</div>
			</div>
			</div>
			</div>

			<div class="bor10 m-t-0 p-t-43 p-b-40" >
				<!-- Tab01 -->
				<div class="tab01">
					<!-- Nav tabs -->
					<ul class="nav nav-tabs" role="tablist">

						<li class="nav-item p-b-10">
							<a class="nav-link active" data-toggle="tab" href="#information" role="tab">Additional information</a>
						</li>
						<li class="nav-item p-b-10">
							<a class="nav-link " data-toggle="tab" href="#description" role="tab">Description</a>
						</li>

						<!-- <li class="nav-item p-b-10">
							<a class="nav-link" data-toggle="tab" href="#reviews" role="tab">Reviews (1)</a>
						</li> -->
					</ul>

					<!-- Tab panes -->
					<div class="tab-content p-t-43">
						<!-- - -->
						<div class="tab-pane fade" id="description" role="tabpanel">
							<div class="how-pos2 p-lr-15-md">
								<p class="stext-102 cl6">
									{{formdata.desc}}
									
								</p>
							</div>
						</div>

						<!-- - -->
						<div class="tab-pane fade active show" id="information" role="tabpanel">
							<div class="row">
								<div class="col-sm-10 col-md-8 col-lg-6 m-lr-auto">
									<!-- <h5 class="mb-2">Network</h5> -->
									
									<ul class="p-lr-28 p-lr-15-sm">
										<li class="flex-w flex-t p-b-7">
											<span class="stext-102 cl3 size-205">
												name
											</span>

											<span class="stext-102 cl6 size-206">
												{{formdata.name}}
											</span>
										</li>
										<li class="flex-w flex-t p-b-7">
											<span class="stext-102 cl3 size-205">
												price
											</span>

											<span class="stext-102 cl6 size-206">
												RS {{formdata.price}}
											</span>
										</li>
										<li class="flex-w flex-t p-b-7">
											<span class="stext-102 cl3 size-205">
												brand/make
											</span>

											<span class="stext-102 cl6 size-206">
												{{formdata.brand}}
											</span>
										</li>
										<li class="flex-w flex-t p-b-7">
											<span class="stext-102 cl3 size-205">
												color
											</span>

											<span class="stext-102 cl6 size-206">
												{{formdata.color}}
											</span>
										</li>
										<li class="flex-w flex-t p-b-7">
											<span class="stext-102 cl3 size-205">
												condition
											</span>

											<span class="stext-102 cl6 size-206">
												{{formdata.condition}}
											</span>
										</li>
										<li class="flex-w flex-t p-b-7">
											<span class="stext-102 cl3 size-205">
												warranty
											</span>

											<span class="stext-102 cl6 size-206">
												{{formdata.warranty}}
											</span>
										</li>
										<li class="flex-w flex-t p-b-7"
											v-for="(value, key) in formdata.details" :key="key" v-if="value != ''">
											<span class="stext-102 cl3 size-205" v-if="key != 'enginecapacity' && key != 'enginetype' && key != 'fueltype'
											 && key != 'bodytype' && key != 'cpugeneration'">
												{{key}}
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'enginecapacity'">
												engine capacity
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'bodytype'">
												body type
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'enginetype'">
												engine type
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'fueltype'">
												fuel type
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'cpugeneration'">
												cpu generation
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'model'|| key == 'size' || key == 'material'
											 || key == 'modelcode' || key == 'year' || key == 'enginetype' || key == 'fueltype' || key == 'transmission'
											 || key == 'bodytype' || key == 'publisher' || key == 'orthor' || key == 'metal' || key == 'cpugeneration' || key == 'os' || key == 'cpu'">
												{{value}}
											</span>

											<span class="stext-102 cl6 size-206" v-if="key == 'storage'|| key == 'ram' || key == 'hard'
											 || key == 'graphics'">
												{{value}} GB
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'frontcamera'|| key == 'rearcamera'">
												{{value}} MP
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'screen'|| key == 'screensize'">
												{{value}} inches
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'karat'">
												{{value}} k
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'weight'">
												{{value}} g
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'battery'">
												{{value}} mAh
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'enginecapacity'">
												{{value}} cc
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'mileage'">
												{{value}} km
											</span>
										</li>

									</ul>
								</div>
							</div>
						</div>

						<!-- - -->
						
					</div>
				</div>
			</div>
		</div>
	


	<!-- Related Products -->
	
	<!-- Modal1 -->
	
  </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import db from "../../config/FirebaseInit"
import {bus} from "../../main"
export default {
  name: 'productdetails',
  data(){
	  return {
		  loaded: false,
		  loading:false,
     	  fetch: false,
		   otherimgsLength:'',
		  isAdded:false,
		   image:'',
		  otherimgs:[],
		  cartItems:0,
		  cartitems:[],
		  ctrl:true,
		   modalShow: false,
		 modalShow2: false,
		 modalShow3: false,
		 shops:[],
		 plan:'',
		  isLoggedIn: false,
		  currentUser: false,
		  isCartItem:'',
		  cartPrdIDs:[],

		  formdata: {
          name: '',
          price:'',
          dis: 0,
          disprice: 0,
          brand: '',
          color: '',
		  cond:'',
		  warranty:'',
          desc: '',
          image: null,
          imageUrl: "",
          imageUrl2:'',
          imageUrl3:'',
          owner:'',
         
         
          model:'',
          cpu:'',
          cpugen:'',
          hard:'',
          storage:'',
          ram:'',
          graphics:'',
          screen:'',
          rearcamera:'',
          frontcamera:'',
          os:'',
          battery:'',
		  weight:'',
		  
		  details:{}
         
        },
	  }
  },
   created () {
    this.$nextTick(() => {
        // $("#zoom_01").elevateZoom({
        // zoomType				: "inner",
        // cursor: "crosshair"
		// });
		// $("#zoom_02").elevateZoom({
        // zoomType				: "inner",
        // cursor: "crosshair"
		// });
		// $("#zoom_03").elevateZoom({
        // zoomType				: "inner",
        // cursor: "crosshair"
		// });
		$('.zoom').zoom();

	})
	this.backToTop()
	this.loading = true
      this.fetch = false
	this.$store.state.secondaryDatabase.collection('products').doc(this.$route.params.id).get()
	 .then(doc => {
     
			 this.otherimgs = doc.data().otherimgs
			 this.otherimgsLength = this.otherimgs.length
			  if(this.otherimgs == undefined || this.otherimgs.length == 0){
			  this.ctrl = false
		  }else if(this.otherimgs.length > 0){
			  this.ctrl = true
		  }
			this.image = doc.data().img

		 this.formdata.name = doc.data().name,
          this.subcategory = doc.data().subcat,
          this.formdata.brand = doc.data().brand,
          this.formdata.price = doc.data().price,
					this.formdata.barcode = doc.data().barcode,
          this.formdata.dis = doc.data().dis,
          this.formdata.color = doc.data().color,
		   this.formdata.condition = doc.data().cond,
        	this.formdata.warranty = doc.data().war,
          this.formdata.desc = doc.data().desc,

		  this.formdata.details = doc.data().details,
          this.formdata.model = doc.data().details.model,
          this.formdata.cpu = doc.data().details.cpu,
          this.formdata.storage = doc.data().details.storage,
          this.formdata.ram = doc.data().details.ram,
          this.formdata.screen = doc.data().details.screen,
          this.formdata.rearcamera =  doc.data().details.rearcamera,
          this.formdata.frontcamera = doc.data().details.frontcamera,
          this.formdata.os = doc.data().details.os,
          this.formdata.battery = doc.data().details.battery,
          this.formdata.weight = doc.data().details.weight,
          this.formdata.cpugen = doc.data().details.cpugen,
          this.formdata.hard = doc.data().details.hard,
          this.formdata.graphics = doc.data().details.graphics
		
		 //this.loaded = true
		  //console.log('other imgs', this.otherimgs)
		   //console.log('other imgs length', this.otherimgsLength)
	 })
	 
	//  .then(() =>{
		
	//  this.fetch = true
	//  })
	 this.$store.state.secondaryDatabase.collection('shops').where('owner', '==', this.$route.params.storename).get()
      .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
			'id':doc.id,
		  'shoptype' : doc.data().shoptype,
		  'plan':doc.data().plan
          
        }
		this.shops.push(data)
		this.plan = this.shops[0].plan
      })
     })
		  
	  if(firebase.auth().currentUser){
		 
			this.$store.state.secondaryDatabase.collection('carts').where('uid', '==', firebase.auth().currentUser.uid)
			.where('shopid', '==', this.$route.params.storename).get()
			.then(querySnapshot => {
			querySnapshot.forEach(doc => {
			const data = {
				'id': doc.id,
				'prdid': doc.data().prdid
			}
			this.cartitems.push(data)
			this.cartItems = this.cartitems.length
			this.cartPrdIDs = this.cartitems.map((citem) => citem.prdid)
			//console.log('this.cartitems',this.cartitems)
			//console.log('this.cartPrdIDs',this.cartPrdIDs)
		})
		var findCartItem = function(citem, id){
			var findedid = citem.find((ci, index) => {
				return ci == id
			})
			return findedid
		}
		if(this.cartPrdIDs != undefined){
			this.isCartItem = findCartItem(this.cartPrdIDs, this.$route.params.id)
		}
		
		//console.log('isCartItem',this.isCartItem)
		// if(this.isCartItem == this.$route.params.id){
			
		// }
		})
		  
	  }
		this.loading = false
		this.fetch = true
	},

  methods: {
	   backToTop: function() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    },
	   cartClicked(){
		  if(!firebase.auth().currentUser){
			  this.modalShow = true
		  }else if(firebase.auth().currentUser){
			  this.cartlink = true
			  this.$router.push({name: 'storecart', params:{storename: this.$route.params.storename}})
		  }
	  },

	 addToCart() {
		  //console.log('added to cart')
		 
		
		if(!firebase.auth().currentUser){
			this.modalShow = true
		}
		if(firebase.auth().currentUser){
        // if(firebase.auth().currentUser.displayName != 'shop owner'){
			if(this.isCartItem != this.$route.params.id){
			// this.cartclr = 'green'
			this.isCartItem = this.$route.params.id
			this.modalShow2 = true
		  //console.log('checked')
		  this.$store.state.secondaryDatabase.collection("carts")
        	.add({
              uid: firebase.auth().currentUser.uid,
			  shopid: this.$route.params.storename,
			  prdid: this.$route.params.id,
			  prdname: this.formdata.name,
				barcode: this.formdata.barcode,
			  quantity: 1,
              price: this.formdata.price,
              total: this.formdata.price,
             img: this.image
             
			})
			.then(doc => {
				
				this.cartItems += 1
				bus.$emit('cartChanged', this.cartItems)
				this.$store.state.cartItems[this.$route.params.storename] += 1
				//console.log(doc.id)
			})
			.catch(error => alert('An error is occured!!!'));
		}else if(this.isCartItem == this.$route.params.id){
			this.modalShow3 = true
		}
		
		// }else if(firebase.auth().currentUser.displayName == 'shop owner'){
		// 	this.modalShow = true
		// 	this.checkval = false
		// }
		}
		// else if(firebase.auth().currentUser && !firebase.auth().currentUser.emailVerified){  
		// 	this.modalShow = true
		// }   
	  },	
  }
}
</script>

<style scoped>
 @import url('~@/assets/main/css/loading.css');
@media (max-width: 767px){   
	.mobi-m-p-100{
		padding-top: 75px;
	}
	.mobi-m-p-0{
		padding-top:0px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/store/ProductDetails.vue